import { useFetchApi, UseFetchDataResponse } from "./useFetchApi";
import { passThroughQueryString } from "./localization/geolocation/geolocationLoader";
import { WindowLocation } from "@reach/router";
import { CruisePrice } from "types/api/suite_price.d";
import { Language } from "./localization/languages/types";

export type CruisePriceResponse = UseFetchDataResponse<CruisePrice>;

const apiURL = `${process.env.GATSBY_DIGITAL_API_BASE_URL}/cruisePriceAndOffers`;

const useCruisePrice = (
  cruiseCode: string | undefined | null,
  location: WindowLocation,
  language: Language
): CruisePriceResponse => {
  const request = cruiseCode
    ? `${apiURL}/${cruiseCode}${passThroughQueryString(location, language)}`
    : undefined;
  return useFetchApi<CruisePrice>(request);
};

export default useCruisePrice;
